module.exports = "/images/delete_icon.svg?611267e2678173742aaf440cae9dcd1f";